module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-num",
    attrs: {
      "id": "P1"
    }
  }, [_vm._v("PART I")]), _vm._v(" "), _c('p', {
    staticClass: "part-title"
  }, [_vm._v("CURSED HOLLYWOOD")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The dictionary defines the word "), _c('i', [_vm._v("curse")]), _vm._v(" as “a solemn utterance intended to invoke a supernatural power to inflict harm or punishment on someone or something.” Although a somewhat technical summation, this definition gets to the heart of the matter: Curses are bad. Many folks don’t believe in the magical aspect of a curse—me, for one. I believe that curses, once known, are self-fulfilling. If you think something will happen, you will make it happen. Others, however, believe so strongly in magic that, once cursed, they will do everything in their power to stop it. They will pay any price, commit any act—even murder—to be released from the curse. And this, of course, usually causes the curse to come to fruition.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Biltmore Hotel, in downtown Los Angeles, was an early venue for the Academy Awards and where “Oscar” himself was born.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Curses are bad enough. But combine a good old-fashioned curse with the over-amped egos and superstitions in Hollywood, and you have a mythos rivaled by none. Hollywood has always had its cast of colorful characters, both on and off the screen. And with these characters comes a whole host of beliefs, ranging from established religion to witchcraft, Druidism and voodooism. You name it, Hollywood has it. Mix in one of Hollywood’s favorite protagonist groups, gypsies, and you have a veritable stew of bad omens, premonitions and, yes, curses. But what happens when a seeming curse hits Hollywood’s grandest event, the Academy Awards? You get a curse that befalls only actresses, never actors. Could it be that Oscar is the ultimate misogynist? Or is it just a matter of bad luck?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9b78c08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part1.vue
// module id = 81
// module chunks = 0